/**
 * Quiet Luxury ATC feedback — loading sync, brief success, bag pulse.
 * Works with Dawn product-form + cart-drawer (luxury PDP + sticky ATC).
 */
(function () {
  'use strict';

  var SUCCESS_MS = 900;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function flashSuccess(btn) {
    if (!btn || btn.disabled) return;
    var label = btn.querySelector('span:not(.ql-pdp-draft__submit-check):not(.loading__spinner)');
    var added = btn.getAttribute('data-label-added') || 'Added';
    var prev = label ? label.textContent : '';

    btn.classList.remove('loading');
    btn.classList.add('is-added');
    if (label) label.textContent = added;

    window.setTimeout(function () {
      btn.classList.remove('is-added');
      if (label && prev) label.textContent = prev;
    }, SUCCESS_MS);
  }

  function pulseBagIcon() {
    var bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble) return;
    bubble.classList.remove('ql-bag-pulse');
    void bubble.offsetWidth;
    bubble.classList.add('ql-bag-pulse');
    window.setTimeout(function () {
      bubble.classList.remove('ql-bag-pulse');
    }, 700);
  }

  function syncStickyLoading() {
    var bar = document.getElementById('marbenio-sticky-atc');
    if (!bar) return;
    var submitId = bar.getAttribute('data-submit-id');
    var mainBtn = submitId ? document.getElementById(submitId) : null;
    var stickyBtn = bar.querySelector('.marbenio-sticky-atc__btn');
    if (!mainBtn || !stickyBtn) return;

    var loading = mainBtn.classList.contains('loading');
    stickyBtn.classList.toggle('loading', loading);
    stickyBtn.classList.toggle('is-added', mainBtn.classList.contains('is-added'));

    var stickySpinner = stickyBtn.querySelector('.loading__spinner');
    if (stickySpinner) stickySpinner.classList.toggle('hidden', !loading);

    var mainLabel = mainBtn.querySelector('span:not(.ql-pdp-draft__submit-check)');
    var stickyLabel = stickyBtn.querySelector('span:not(.ql-pdp-draft__submit-check)');
    if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent.trim();
  }

  function bindMainButtonObserver() {
    var bar = document.getElementById('marbenio-sticky-atc');
    var submitId = bar && bar.getAttribute('data-submit-id');
    var mainBtn = submitId ? document.getElementById(submitId) : document.querySelector('.ql-pdp-draft__submit');
    if (!mainBtn) return;

    var obs = new MutationObserver(syncStickyLoading);
    obs.observe(mainBtn, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
    syncStickyLoading();
  }

  function onCartUpdate(event) {
    if (!event || event.source !== 'product-form') return;
    var btn = document.querySelector('.ql-pdp-draft__submit.product-form__submit');
    if (!btn) btn = document.querySelector('product-form [type="submit"]');
    if (!reduced) {
      flashSuccess(btn);
      pulseBagIcon();
    }
    syncStickyLoading();
  }

  function init() {
    bindMainButtonObserver();

    if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }

    document.addEventListener('click', function (e) {
      var sticky = e.target.closest && e.target.closest('.marbenio-sticky-atc__btn');
      if (!sticky) return;
      /* Sticky shares the form; ensure main button shows loading ASAP */
      var bar = document.getElementById('marbenio-sticky-atc');
      var submitId = bar && bar.getAttribute('data-submit-id');
      var mainBtn = submitId ? document.getElementById(submitId) : null;
      if (mainBtn && !mainBtn.disabled) {
        window.requestAnimationFrame(syncStickyLoading);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
